import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import {
  HttpUtilsService,
  QueryParamsModel,
  QueryResultsModel,
} from '../../core/_base/crud';

export class CrudService<T> {
  static defaultHeaders = new HttpHeaders({
    'Content-Type': 'application/ld+json',
    Accept: 'application/ld+json',
  });

  lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(
    new QueryParamsModel({}, 'desc', 'id', 1, 30)
  );

  API_URL: string;

  constructor(
    protected _API_URL: string,
    protected http: HttpClient,
    protected httpUtils: HttpUtilsService
  ) {
    this.API_URL = _API_URL;
  }

  list(queryParams: QueryParamsModel, customUrl = null) {
    const params = this.httpUtils.getFindHTTPParams(queryParams);
    const apiUrl = customUrl ? customUrl : this.API_URL;
    return this.http.get<QueryResultsModel>(apiUrl, { params });
  }

  loadByID(id: number) {
    return this.http.get<T>(`${this.API_URL}/${id}`);
  }

  private create(record: T) {
    const httpOptions = {
      headers: CrudService.defaultHeaders,
    };
    return this.http.post(this.API_URL, record, httpOptions).pipe(take(1));
  }

  private update(record: any) {
    const httpOptions = {
      headers: CrudService.defaultHeaders,
    };

    return this.http
      .put(`${this.API_URL}/${record['id']}`, record, httpOptions)
      .pipe(take(1));
  }

  save(record: any) {
    if (record['id']) {
      return this.update(record);
    }
    return this.create(record);
  }

  remove(id: number) {
    return this.http.delete(`${this.API_URL}/${id}`).pipe(take(1));
  }

  removeRecords(ids: number[] = []) {
    const tasks$: Observable<any>[] = [];
    ids.forEach((id) => {
      tasks$.push(this.remove(id));
    });
    return forkJoin(tasks$).pipe(take(1));
  }
}
